import React from "react";
import {
  html,
  css,
  github,
  javascript,
  node,
  reactImage,
  tailwind,
  firebase,
  nextjs,
  shadcn,
  git,
  mongoDB,
} from "../assets/skills/skills";

const Experience = () => {
  const techs = [
    { id: 1, src: javascript, name: "JS", style: "shadow-yellow-500" },
    { id: 2, src: node, name: "NodeJS", style: "shadow-green-700" },
    { id: 3, src: reactImage, name: "React", style: "shadow-blue-600" },
    { id: 4, src: nextjs, name: "NextJS", style: "shadow-gray-400" },
    { id: 5, src: html, name: "Html", style: "shadow-orange-500" },
    { id: 6, src: css, name: "CSS", style: "shadow-blue-500" },
    { id: 7, src: tailwind, name: "Tailwind", style: "shadow-sky-400" },
    { id: 8, src: shadcn, name: "ShadCN", style: "shadow-slate-400" },
    { id: 9, src: mongoDB, name: "MongoDB", style: "shadow-green-400" },
    { id: 10, src: firebase, name: "Firebase", style: "shadow-yellow-400" },
    { id: 11, src: git, name: "Git", style: "shadow-orange-400" },
    { id: 12, src: github, name: "Github", style: "shadow-gray-400" },
  ];

  return (
    <div name="experience" className="w-full my-32">
      <div className="mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className=" text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Experience
          </p>
          <p className="py-6">Technologies I've worked with </p>
        </div>

        <div className=" w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, name, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style} cursor-pointer`}
            >
              <img src={src} alt="" className=" w-20 mx-auto pt-4" />
              <p className="mt-4">{name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
